import { apiFetch } from "@/lib/api"

export const getAiUsage = () => apiFetch("/api/v1/ai-usage")
